
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Picker from 'vux/src/components/picker/index.vue'

export default {
components: {
XInput,
XButton,
Group,
Cell,
PopupPicker,
Picker
},
data () {
return {
routeline: [],
list1: [['USEC(美东)',
'PNW(美西北)',
'PSW(美西南)',
'EUR(欧洲)',
'MED(地中海)',
'AUS(澳新)',
'ISC(印巴)',
'TW(台湾)',
'VN(越南)',
'JP(日本)',
'TH(泰国)',
'KR(韩国)',
'ID(印尼)',
'MY(马来西亚)/SIN(新加坡)',
'PH(菲律宾)',
'ME(中东)',
'RED(红海)',
'SAFR(南非)',
'WAFR(西非)',
'EAFR(东非)',
'LAT(拉美)']]
}
},
methods: {
searchSubmit: function () {
let that = this
if (that.$Utils.IsEmpty(that.routeline)) {
that.$Msgbox.alert('请选择航线', '异常提示')
} else {
let url = '/wx/blanksailing/blankSailingList?routeline=' + that.routeline
window.location.href = url
}
},
onShow () {
console.log('on show')
},
onHide (type) {
console.log('on hide', type)
},
onChange (val) {
console.log('val change', val)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/blanksailing/BlankSailingSearchPage.vue